import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CardContainer from "../../_utils/CommonViewAllCard/CardContainer";
import TextWithIcon from "../../_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import TextWithCTA from "../../_utils/CommonViewAllCard/CardSubComponent/TextWithCTA";
import accountNameStandardised from "../../../utils/accountNamestandardised";
import formatDateViewAll from "../../../utils/formatDateViewAll";
import {
  GlobalConfiguration,
  ScreenSizeConfiguration,
} from "../../../utils/configurationProvider";
import {
  resetBeneTxnMultiApprovalError,
  resetBeneTxnMultiDeniedApprovalData,
} from "../../../redux/features/beneficiary/beneTxnViewAccData/beneTxnViewAccData";
import CommonToast from "../../_utils/CommonToast";
import ICONS from "../../../assets/Icons";

const FieldForceTxnMultiCard = ({
  filterRef,
  filterOpen,
  data,
  setselectAllCard,
  selectedTransactions,
  setSelectedTransactions,
  setTotalAmount,
  setSelectedSendTransactions,
  selectedSendTransactions,
  SideDrawerOpen,
  setTxnId,
  openBeneTxnDetailModal,
  maxSelectionLimit,
}) => {
  const dispatch = useDispatch();
  const [isMobileResponsive, setIsMobileResponsive] = useState(
    window.innerWidth <= ScreenSizeConfiguration.mobileScreen,
  );
  const [isTabResponsive, setIsTabResponsive] = useState(
    window.innerWidth <= ScreenSizeConfiguration.tabScreen,
  );

  const { BeneTxnMultiApprovalError, BeneTxnMultiDeniedApprovalError } =
    useSelector((state) => state?.beneTxnViewAccData);

  useEffect(() => {
    dispatch(resetBeneTxnMultiApprovalError());
    dispatch(resetBeneTxnMultiDeniedApprovalData());
  }, [BeneTxnMultiApprovalError, BeneTxnMultiDeniedApprovalError, dispatch]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileResponsive(
        window.innerWidth <= ScreenSizeConfiguration.mobileScreen,
      );
      setIsTabResponsive(
        window.innerWidth <= ScreenSizeConfiguration.tabScreen,
      );
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--settled)";
      case "denied":
      case "failed":
      case "rejected":
        return "var(--failed)";
      case "abandoned":
        return "var(--abandoned)";
      case "hold":
      case "queued":
        return "var(--queued)";
      default:
        return "var(--settled)";
    }
  };

  const handleCardClick = (account) => {
    const approvalStatus =
      account?.field_force_account_approval_status ||
      account?.beneficiary_account_approval_status;

    if (approvalStatus === "approved") {
      const maxLimit = maxSelectionLimit;
      const cardAmount = Number(account.amount);
      const isSelected = selectedTransactions.includes(account.txn_id);

      if (isSelected) {
        setselectAllCard(false);
        setTotalAmount((prevAmount) =>
          Math.max(0, (parseFloat(prevAmount) || 0) - cardAmount),
        );
        setSelectedTransactions((prevSelected) =>
          prevSelected.filter((id) => id !== account.txn_id),
        );
        setSelectedSendTransactions((prevSend) =>
          prevSend.filter((val) => val?.txn_id !== account.txn_id),
        );
      } else {
        if (selectedTransactions.length < maxLimit) {
          setTotalAmount(
            (prevAmount) => (parseFloat(prevAmount) || 0) + cardAmount,
          );
          setSelectedTransactions((prevSelected) => [
            ...prevSelected,
            account.txn_id,
          ]);
          setSelectedSendTransactions((prevSend) => [...prevSend, account]);
        }
      }
    }
  };

  const handleCtaClick = (e, account) => {
    e.stopPropagation();
    if (!sessionStorage.getItem("q2p_token")) return;

    const approvalStatus = account?.field_force_account_approval_status;

    const accountId = account?.field_force_account_id;

    if (approvalStatus === "pending") {
      SideDrawerOpen(accountId, account.txn_id);
    } else {
      openBeneTxnDetailModal();
      setTxnId(account.txn_id);
    }
  };

  return (
    <div className="standard-card-alignment gap-x-gap-sm gap-y-gap-md">
      {data?.map((account) => {
        const approvalStatus = account?.field_force_account_approval_status;

        return (
          <CardContainer
            filterRef={filterRef}
            hoverHeight={
              GlobalConfiguration?.beneTxnMultiApprovalCardHoverHeight
            }
            isDisabled={approvalStatus === "pending" ? true : false}
            key={account?.txn_id}
            isSelected={selectedTransactions.includes(account.txn_id)}
            onClickHandler={() => handleCardClick(account)}
            varaint="overlay"
          >
            <card-body>
              <TextWithIcon
                type={approvalStatus === "pending" ? "Text" : "Amount"}
                fontWeight="semibold"
                text={
                  approvalStatus === "pending"
                    ? "Account approval pending"
                    : account?.amount
                }
                textColor={getStatusColor(approvalStatus)}
                subText={
                  approvalStatus === "pending" ? "Account status" : "Amount"
                }
                iconComponentArray={
                  approvalStatus !== "pending"
                    ? [
                        ...(account?.confidential_transaction === "Y"
                          ? [
                              {
                                icon: ICONS?.CONFIDENTIAL_TRANSACTION,
                                title: "confidential",
                                isDisabled: false,
                              },
                            ]
                          : []),
                        {
                          icon: selectedTransactions.includes(account?.txn_id)
                            ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                            : ICONS?.NOT_SELECTED_WITH_GREY_CIRCLE,
                          isDisabled: false,
                        },
                      ]
                    : []
                }
              />
              <TextWithIcon
                type="Text"
                fontWeight="var(--font-normal)"
                text={accountNameStandardised(account.field_force_account_name)}
                textColor="var(--text-primary)"
                subText="Account name"
              />
              <TextWithCTA
                btnText={
                  approvalStatus === "pending" ? "View account" : "More details"
                }
                enabledBgColor="var(--text-primary)"
                enabledTextColor="var(--primary-bg)"
                handleFunction={(e) => handleCtaClick(e, account)}
                icon={ICONS?.ARROW_RIGHT_WHITE}
                isDisabled={!!filterOpen}
                text={
                  account.created_on
                    ? formatDateViewAll(account.created_on, false, false)
                    : "Not given"
                }
                subText="Date"
                type="Text"
              />
            </card-body>

            <card-hover>
              <div className="flex flex-col gap-y-gap-sm">
                <TextWithIcon
                  text={
                    account?.labels?.length
                      ? account.labels.join(", ")
                      : "Not assigned"
                  }
                  fontWeight="normal"
                  textColor="var(--text-primary)"
                  iconComponentArray={[
                    {
                      icon: ICONS?.LABEL,
                    },
                  ]}
                />
              </div>
            </card-hover>
          </CardContainer>
        );
      })}
    </div>
  );
};

export default FieldForceTxnMultiCard;
